import { render, staticRenderFns } from "./question-set-answering.vue?vue&type=template&id=0cdc3ba9&scoped=true"
import script from "./question-set-answering.vue?vue&type=script&lang=js"
export * from "./question-set-answering.vue?vue&type=script&lang=js"
import style0 from "./question-set-answering.vue?vue&type=style&index=0&id=0cdc3ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc3ba9",
  null
  
)

export default component.exports